module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"contacts":"{contacts} active contacts in this automation. | 1 active contact in this automation.","deals":"{deals} deals in this automation. | 1 deal in this automation.","view":"View"}}')
  delete Component.options._Ctor
}
